export enum EHydraCreditNoteState {
  unpublished = 'unpublished',
  draft = 'draft',
  deleted = 'deleted',
  sent = 'sent',
  void = 'void',
}

const hydraCreditNoteStateDisplayNames: Record<EHydraCreditNoteState, string> = {
  [EHydraCreditNoteState.unpublished]: 'Unpublished',
  [EHydraCreditNoteState.draft]: 'Draft',
  [EHydraCreditNoteState.deleted]: 'Deleted',
  [EHydraCreditNoteState.sent]: 'Published',
  [EHydraCreditNoteState.void]: 'Void',
};

/**
 * Returns a human-readable display name for a given {@link EHydraCreditNoteState} value.
 *
 * Notable mapping: the internal `sent` state is displayed as `"Published"` to match
 * the terminology used in the UI.
 *
 * For unknown state strings, the function falls back to capitalising the first character
 * and replacing underscores/hyphens with spaces.
 *
 * @param state - The credit note state to look up. Accepts `EHydraCreditNoteState`, a raw
 *   string, `null`, or `undefined`.
 * @returns A formatted display string, or an empty string if `state` is falsy.
 */
export const getHydraCreditNoteStateDisplayName = (
  state?: EHydraCreditNoteState | string | null,
) => {
  if (!state) {
    return '';
  }

  return hydraCreditNoteStateDisplayNames[state as EHydraCreditNoteState]
    ?? state.replace(/[_-]/g, ' ').replace(/^\w/, (char) => char.toUpperCase());
};

export enum EHydraCreditNoteVoidState {
  voidRequested = 'void-requested',
  voidDenied = 'void-denied',
  voidApproved = 'void-approved',
}

export enum EThirdParty {
  xero = 'xero',
  freshbooks = 'freshbooks'
}
